var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('Menu',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]}),_c('MbrEdit2',{attrs:{"mbr":_vm.user,"regs":_vm.regs,"menu":true,"v:show":"!loading"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }